/*
 * Copyright (c) 2026. Bluemate B.V.
 */
import React from 'react';

import upload from '@iconify/icons-feather/upload';

import {useTranslation} from 'react-i18next';

import BluemateSetupCard from './bluemateSetupCard';

interface Props {
    completed?: boolean;
    onClick?: () => void;
    onCheckClick?: () => void;
    className?: string;
}

export default function BluemateInvoiceUploadCard(props: Props) {
    const {completed, onClick, onCheckClick, className} = props;
    const {t} = useTranslation();

    return (
        <BluemateSetupCard
            className={className}
            title={t('controls.setupCard.invoiceUpload.title', 'Auto-upload')}
            subtitle={t('controls.setupCard.invoiceUpload.subtitle', 'Upload facturen naar Bol')}
            icon={upload}
            completed={completed}
            onClick={onClick}
            onCheckClick={onCheckClick}
        />
    );
}
